
import { Component, Vue } from 'vue-property-decorator';
import InfoTooltip from '@/app/components/common/InfoTooltip.vue';
import { AuthorityType } from 'ah-api-gateways';
import TradesSidebarView from '@/app/views/dashboard/trades/TradesSidebarView.vue';
import SideNavTradeLink from './SideNavTradeLink.vue';
import SideNavSettingsLink from './SideNavSettingsLink.vue';
import { useAuthStore } from '@/app/store/authModule';

@Component({
  components: {
    InfoTooltip,
    TradesSidebarView,
    SideNavTradeLink,
    SideNavSettingsLink,
  },
})
export default class ClientResponsiveNav extends Vue {
  get authStore() {
    return useAuthStore();
  }

  get canViewTrades() {
    return this.authStore.hasAuthorities(AuthorityType.VIEW_TRADES);
  }
}
